//import store from '../redux/store';  // Import the Redux store
import { store } from "../redux/store";
import { logout } from "../redux/actions/authActions";

// const TokenExpired = () => {
//     const history = useHistory();
//     const dispatch = useDispatch();

//     const redirectToLogin = useCallback(() => {
//         dispatch(logout(history));
//     }, [dispatch, history]);

//     useEffect(() => {
//         redirectToLogin();
//     }, [redirectToLogin]);

//     return (
//         <div>
//             <p>Session expired. Redirecting to login...</p>
//         </div>
//     );
// };

// export default TokenExpired;

// Function to handle token expiration
export const tokenExpired = () => {
  // Dispatch the logout action to clear user data from the store
  store.dispatch(logout());

  // Redirect the user to the login page
  //window.location.href = '/dashboard/login';
};
